import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  BeachAccess,
  Castle,
  Landscape,
  Download,
} from '@mui/icons-material';
import at1 from '../assets/images/at1.jpg';
import at2 from '../assets/images/at2.jpg';
import at3 from '../assets/images/at3.jpg';
import at4 from '../assets/images/at4.jpg';
import at5 from '../assets/images/at5.jpg';
import at6 from '../assets/images/at6.jpg';
 import brochure from '../assets/brochure.pdf';

const Attractions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const attractions = [
    {
      id: 1,
      name: 'Guhagar Beach',
      image: at1,
      description: 'Beautiful sandy beach with crystal clear waters',
      icon: <BeachAccess sx={{ fontSize: 40, color: 'primary.main' }} />,
      location: 'https://www.google.com/maps?q=Guhagar+Beach',
    },
    {
      id: 2,
      name: 'Vyadeshwar Temple',
      image: at2,
      description: 'Historic temple dedicated to Lord Shiva, located near the pristine  Beach, known for its spiritual significance and coastal beauty',
      icon: <BeachAccess sx={{ fontSize: 40, color: 'primary.main' }} />,
      location: 'https://www.google.com/maps?q=Vyadeshwar+Temple+Guhagar',
    },
    {
      id: 3,
      name: 'Light House Hill',
      image: at3,
      description: 'Scenic hilltop offering panoramic views of the Arabian Sea and surrounding coastline',
      icon: <BeachAccess sx={{ fontSize: 40, color: 'primary.main' }} />,
      location: 'https://www.google.com/maps?q=Light+House+Hill+Guhagar',
    },
    {
      id: 4,
      name: 'Velneshwar Temple',
      image: at4,
      description: 'Historic temple dedicated to Lord Shiva, located near the pristine Velneshwar Beach',
      icon: <BeachAccess sx={{ fontSize: 40, color: 'primary.main' }} />,
      location: 'https://www.google.com/maps?q=velneshwar+Temple',
    },
    
    {
      id: 5,
      name: 'Velneshwar Beach',
      image: at5,
      description: 'Pristine beach perfect for relaxation and water sports',
      icon: <Landscape sx={{ fontSize: 40, color: 'primary.main' }} />,
      location: 'https://www.google.com/maps?q=velneshwar+Beach',
    },
    {
      id: 6,
      name: 'Gopalgad',
      image: at6,
      description: 'Historic fort with stunning views of the coastline',
      icon: <Castle sx={{ fontSize: 40, color: 'primary.main' }} />,
      location: 'https://www.google.com/maps?q=Gopalgad+Fort',
    },

  ];

  return (
    <Box sx={{ py: 8, backgroundColor: 'white' }}>
      <Container maxWidth="lg">
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Button
            component="a"
            href={brochure}
            download
            variant="contained"
            color="primary"
            startIcon={<Download />}
            sx={{ px: 4, py: 1.5, fontWeight: 700 }}
          >
            Download Brochure
          </Button>
        </Box> */}
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 2, fontWeight: 700, color: 'primary.main' }}
        >
          Attractions
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{ mb: 6, color: 'text.secondary' }}
        >
          Vacation Unleashed Discover Hotel Area Attractions
        </Typography>

        <Grid container spacing={4}>
          {attractions.map((attraction) => (
            <Grid item xs={12} md={4} key={attraction.id}>
              <Card
                elevation={4}
                sx={{
                  height: '100%',
                  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: theme.shadows[12],
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={attraction.image}
                  alt={attraction.name}
                  sx={{ objectFit: 'cover' }}
                />
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {attraction.icon}
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{ ml: 2, fontWeight: 600, color: 'primary.main' }}
                    >
                      {attraction.name}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 3, lineHeight: 1.6 }}
                  >
                    {attraction.description}
                  </Typography>
                  <Button
                    component="a"
                    href={attraction.location}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outlined"
                    color="primary"
                    fullWidth
                    sx={{ fontWeight: 600 }}
                  >
                    View Location
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Attractions; 